const toggleLayer = (map, layersVisibility, setLayersVisibility, layerIds) => {
  console.log('LAYERIDs in toggleLayer: ', layerIds);
  if (!map) return;

  // Helper function to toggle visibility
  const setLayerVisibility = (layerId, visibility) => {
    const layerExists = map.getLayer(layerId) !== undefined;
    if (layerExists) {
      map.setLayoutProperty(layerId, 'visibility', visibility ? 'visible' : 'none');
      setLayersVisibility(prevState => ({
        ...prevState,
        [layerId]: visibility
      }));
    }
  };

  // Handle the interdependency logic when layer A activated then others need to be deactiveted
  layerIds.forEach(layerId => {
    if (layerId === 'immo_layer-fill-extrusion') {
      if (
        map.getLayoutProperty('blocks_layer-fill', 'visibility') === 'visible' ||
        map.getLayoutProperty('blocks_layer_gfz-fill', 'visibility') === 'visible' ||
        map.getLayoutProperty('blocks_layer_property_value_change-fill', 'visibility') === 'visible' ||
        map.getLayoutProperty('blocks_layer_construction_year_type-fill', 'visibility') === 'visible' ||
        map.getLayoutProperty('blocks_layer_grz_i-fill', 'visibility') === 'visible'
      ) {
        setLayerVisibility('blocks_layer-fill', false);
        setLayerVisibility('blocks_layer_gfz-fill', false);
        setLayerVisibility('blocks_layer_property_value_change-fill', false);
        setLayerVisibility('blocks_layer_construction_year_type-fill', false);
        setLayerVisibility('blocks_layer_grz_i-fill', false);
      }
    } else if (layerId === 'flurstuecke-fill' || layerId === 'flurstuecke-line') {
      if (
        map.getLayoutProperty('blocks_layer-fill', 'visibility') === 'visible' ||
        map.getLayoutProperty('blocks_layer_gfz-fill', 'visibility') === 'visible' ||
        map.getLayoutProperty('blocks_layer_property_value_change-fill', 'visibility') === 'visible' ||
        map.getLayoutProperty('blocks_layer_construction_year_type-fill', 'visibility') === 'visible' ||
        map.getLayoutProperty('blocks_layer_grz_i-fill', 'visibility') === 'visible'
      ) {
        setLayerVisibility('blocks_layer-fill', false);
        setLayerVisibility('blocks_layer_gfz-fill', false);
        setLayerVisibility('blocks_layer_property_value_change-fill', false);
        setLayerVisibility('blocks_layer_construction_year_type-fill', false);
        setLayerVisibility('blocks_layer_grz_i-fill', false);
      }
    } else if (layerId === 'blocks_layer-fill') {
      const otherLayers = ['immo_layer-fill-extrusion', 'flurstuecke-fill', 'flurstuecke-line', 'blocks_layer_gfz-fill', 'blocks_layer_property_value_change-fill', 'blocks_layer_construction_year_type-fill', 'blocks_layer_grz_i-fill'];
      otherLayers.forEach(otherLayer => {
        if (map.getLayoutProperty(otherLayer, 'visibility') === 'visible') {
          setLayerVisibility(otherLayer, false);
        }
      });
    } else if (layerId === 'blocks_layer_gfz-fill') {
      const otherLayers = ['immo_layer-fill-extrusion', 'flurstuecke-fill', 'flurstuecke-line', 'blocks_layer-fill', 'blocks_layer_property_value_change-fill', 'blocks_layer_construction_year_type-fill', 'blocks_layer_grz_i-fill'];
      otherLayers.forEach(otherLayer => {
        if (map.getLayoutProperty(otherLayer, 'visibility') === 'visible') {
          setLayerVisibility(otherLayer, false);
        }
      });
    } else if (layerId === 'blocks_layer_property_value_change-fill') {
      const otherLayers = ['immo_layer-fill-extrusion', 'flurstuecke-fill', 'flurstuecke-line', 'blocks_layer-fill', 'blocks_layer_gfz-fill', 'blocks_layer_construction_year_type-fill', 'blocks_layer_grz_i-fill'];
      otherLayers.forEach(otherLayer => {
        if (map.getLayoutProperty(otherLayer, 'visibility') === 'visible') {
          setLayerVisibility(otherLayer, false);
        }
      });
    } else if (layerId === 'blocks_layer_construction_year_type-fill') {
      const otherLayers = ['immo_layer-fill-extrusion', 'flurstuecke-fill', 'flurstuecke-line', 'blocks_layer-fill', 'blocks_layer_gfz-fill', 'blocks_layer_property_value_change-fill', 'blocks_layer_grz_i-fill'];
      otherLayers.forEach(otherLayer => {
        if (map.getLayoutProperty(otherLayer, 'visibility') === 'visible') {
          setLayerVisibility(otherLayer, false);
        }
      });
    } else if (layerId === 'blocks_layer_grz_i-fill') {
      const otherLayers = ['immo_layer-fill-extrusion', 'flurstuecke-fill', 'flurstuecke-line', 'blocks_layer-fill', 'blocks_layer_gfz-fill', 'blocks_layer_property_value_change-fill', 'blocks_layer_construction_year_type-fill'];
      otherLayers.forEach(otherLayer => {
        if (map.getLayoutProperty(otherLayer, 'visibility') === 'visible') {
          setLayerVisibility(otherLayer, false);
        }
      });
    }
  });

  // Iterate through each layerId in the array
  layerIds.forEach(layerId => {
    const layerExists = map.getLayer(layerId) !== undefined;

    if (layerExists) {
      const currentVisibility = map.getLayoutProperty(layerId, 'visibility');

      // Toggle the visibility state for each layer
      if (currentVisibility === 'visible') {
        setLayerVisibility(layerId, false); // Set the specific layer's visibility to false
      } else {
        setLayerVisibility(layerId, true); // Set the specific layer's visibility to true
      }
    } else {
      console.warn(`Layer "${layerId}" does not exist.`);
    }
  });
};

export default toggleLayer;
